import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return <footer />;
  }
}

export default Footer;
